import { NetworkIntegrityProviderTypes } from "@app/projects/network-assessment/network-integrity/filters/networkIntegrityFilterConstants";
import { getDisplayProviderType } from "@app/projects/network-assessment/network-integrity/helpers/networkIntegrityFilterHelper";
import { JSX } from "react";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface NetworkIntegrityProviderTypeFilterProps {
  providerType: string;
  setProviderType: (value: string) => void;
  hasProspectProviders: boolean;
  onlyServicingProviders?: boolean;
}

const NetworkIntegrityProviderTypeFilter = (props: NetworkIntegrityProviderTypeFilterProps): JSX.Element => {  
  const { providerType, setProviderType, hasProspectProviders } = props;

  const handleProviderTypeChange = (value: string): void => {
    if (value !== providerType) {
      setProviderType(value);
    }
  }

  const getProviderTypeList = (): string[] => {
    let providerTypeList: string[] = [];

    for (const t of Object.values(NetworkIntegrityProviderTypes)) {
      providerTypeList.push(t);
    }

    if(props.onlyServicingProviders)
      providerTypeList = providerTypeList.filter(t => t != NetworkIntegrityProviderTypes.Network && t != NetworkIntegrityProviderTypes.Prospect);

    if (hasProspectProviders)
      return providerTypeList;

    return providerTypeList.filter(t => t != NetworkIntegrityProviderTypes.Prospect
      && t != NetworkIntegrityProviderTypes.ProspectServicing);
  }

  // Maps internal providerType (e.g. "Servicing") to the option value shown in the list for dual membership configs.
  const getSelectValue = (type: string): string => {
    const tmpType = type ?? providerType;
    return tmpType;
  };

  return (
    <QESSelect
      label="View Providers:"
      testId="network-integrity-filters__provider-type"
      value={getSelectValue(providerType)}
      onChange={(e) => handleProviderTypeChange(e.target.value)}
      className="network-integrity-filters__provider-type"
      disabled={getProviderTypeList().length == 1}
    >
      {getProviderTypeList().map((t) => {
        return (
          <option key={`network-integrity-filters__provider-type-option--${t}`} value={t}>
            {getDisplayProviderType(t)}
          </option>
        );
      })}
    </QESSelect>
  );
}

export default NetworkIntegrityProviderTypeFilter;